import React from "react";
import { CustomSpinner } from "./styles";

const Spinner = () => {
  return <CustomSpinner />;
};

export default Spinner;
